import { Box, Typography, useMediaQuery } from "@mui/material";

const FormattedText = ({ text }) => {
  // Diviser le texte en lignes
  const lines = text.split('\n');
  const isMobile = useMediaQuery('(max-width:600px)');

  const getTitleFontSize = (index) => {
    if (isMobile) {
      return index === 0 ? "1.6em" : "0.8em"
    } else {
      return index === 0 ? "2em" : "1.2em"
    }
  }

  const getParagraphFontSize = (index) => {
    if (isMobile) {
      return index >= 1 ? "0.7em" : "0.9em"
    } else {
      return index === 0 ? "1.2em" : "1.2em"
    }
  }

  // Tableau pour regrouper les lignes par paragraphe
  const paragraphs = [];
  let currentParagraph = [];

  lines.forEach((line) => {
    if (line.trim() === '') {
      if (currentParagraph.length > 0) {
        paragraphs.push(currentParagraph);
        currentParagraph = [];
      }
    } else {
      currentParagraph.push(line.trim());
    }
  });

  if (currentParagraph.length > 0) {
    paragraphs.push(currentParagraph);
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width:"100%" }}>
      {/* Premier paragraphe */}
      {paragraphs[0] && (
        <Box
          sx={{
            marginBottom: isMobile ? "20px" : "30px", // Marges adaptées pour mobile ou desktop
          }}
        >
          {paragraphs[0].map((line, index) => (
            <Typography
              key={index}
              variant="text"
              fontFamily={"Roboto"}
              sx={{
                display: 'block',
                width: "fit-content",
                backgroundColor: index === 0 ? '#0E101F' : "white",
                color: index === 0 ? 'white' : "#0E101F",
                fontSize: getTitleFontSize(index),
                lineHeight: 1,
                padding: "3px",
              }}
            >
              {line}
            </Typography>
          ))}
        </Box>
      )}

      {/* Paragraphes 2 et 3 affichés en row sur mobile */}
      <Box
        sx={{
          display: isMobile ? 'flex' : 'block', // Affiche en ligne sur mobile, sinon en colonne
          flexDirection: isMobile ? 'row' : 'column',
          gap: isMobile ? '20px' : '0', // Espacement entre les paragraphes en row
        }}
      >
        {paragraphs.slice(1).map((paragraph, index) => (
          <Box
            key={index}
            sx={{
              flex: isMobile ? 1 : 'unset', // Ajuste la largeur des colonnes sur mobile
              marginBottom: !isMobile ? "20px" : "0",
            }}
          >
            {paragraph.map((line, lineIndex) => (
              <Typography
                key={lineIndex}
                variant="text"
                fontFamily={"Roboto"}
                sx={{
                  display: 'block',
                  width: "fit-content",
                  backgroundColor: 'transparent',
                  color: '#0E101F',
                  fontSize: getParagraphFontSize(index), // Taille réduite pour le 3e paragraphe
                  lineHeight: 1,
                  padding: "3px",
                  paddingBottom: "0px",
                  marginBottom: "0px",
                }}
              >
                {line}
              </Typography>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FormattedText;
